import { useCallback, useEffect, useState } from "react";

function useDocumentDetailTable({  data}) {
  const [allData, setAllData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalShow, setTotalShow] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentData, setCurrentData] = useState([]);


  const _processData = () => {
    const from = currentPage * totalShow - totalShow;
    let to = currentPage * totalShow;
    if (from <= data.length) {
      to = to <= data.length ? to : data.length;
      setCurrentData(data.slice(from, to));
    }
  };

  useEffect(() => {
    _processData();
  }, [currentPage, data]);

  useEffect(() => {
    if (data?.length) {
      setAllData(data);
      // setData(data);
    }
  }, [data]);

  const handlePageChange = useCallback(
    (type) => {
      console.log("_handlePageChange", type);
      if (Math.ceil(data.length / totalShow) >= type + 1) {
        setCurrentPage(type + 1);
        _processData();
      }
    },
    [_processData, setCurrentPage, data, totalShow]
  );

  const queryFilter = useCallback((key, value) => {}, []);

  const handleFilterDataChange = useCallback(
    (value) => {
      queryFilter("FILTER_DATA", value);
    },
    [queryFilter]
  );

  

const handleSearchValueChange = useCallback(
  (value) => {
    if (value) {
      const searchWords = value.toLowerCase().split(/\s+/).filter(Boolean);

      const tempData =
        allData?.filter((val) => {
          const name = val?.name?.toLowerCase() || "";
          return searchWords.every((word) => name.includes(word));
        }) || [];

      setCurrentData(tempData); 
    } else {
      _processData(); 
    }
  },
  [allData, _processData]
);


  return {
    data,
    handleSearchValueChange,
    isLoading,
    currentData,
    handlePageChange,
    currentPage,
  };
}

export default useDocumentDetailTable;
